module.exports = __webpack_public_path__ + "img/logo-for-webpage-nav-bar-text-only.79cbae12.svg";